import { fieldFallbackLabel } from "@smart/bridge-intake-components-dom";
import { FieldNS, GroupNS, SectionNS } from "@smart/bridge-types-basic";
import { removeMarkdown } from "@smart/itops-serialisation-basic";

import {
  GqlFieldValues,
  GqlGroupValues,
  GqlSectionValues,
  ItemType,
} from "../../../types";

export const getItemType = (uri?: string): ItemType | undefined => {
  if (!uri) return undefined;
  if (SectionNS.isUriMatch(uri)) return "Section";
  if (GroupNS.isUriMatch(uri)) return "Group";
  if (FieldNS.isUriMatch(uri)) return "Field";

  return undefined;
};

export type ConditionItem = GqlFieldValues | GqlGroupValues | GqlSectionValues;

export const isConditionSection = (
  item: ConditionItem | null,
): item is GqlSectionValues => !!item && SectionNS.isUriMatch(item.uri);

export const isConditionGroup = (
  item: ConditionItem | null,
): item is GqlGroupValues => !!item && GroupNS.isUriMatch(item.uri);

export const isConditionField = (
  item: ConditionItem | null,
): item is GqlFieldValues => !!item && FieldNS.isUriMatch(item.uri);

export const getItemLabel = (
  item: ConditionItem | null,
  removeMarkdownFormatting?: boolean,
) => {
  let label: string;

  if (!item) return "";
  if (isConditionSection(item))
    label = item.title || fieldFallbackLabel.section;
  else if (isConditionGroup(item))
    label = item.label || fieldFallbackLabel.group;
  else label = item.label || fieldFallbackLabel[item.type];

  return removeMarkdownFormatting ? removeMarkdown(label) : label;
};
